import {
  Component,
  Input,
  OnInit,
  EventEmitter,
  Output,
  Inject,
  PLATFORM_ID,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
} from '@angular/core';
import { MainLayoutComponent } from '../../layout/main-layout/main-layout.component';
import { isPlatformBrowser } from '@angular/common';
import { BetService } from '../../services/bet.service';
import { filter, take, tap } from 'rxjs/operators';

@Component({
  selector: 'app-your-betting-info',
  templateUrl: './your-betting-info.component.html',
  styleUrls: ['./your-betting-info.component.scss'],
})
export class YourBettingInfoComponent implements OnInit, OnChanges {
  @Input() info;
  @Input() raceDate;
  @Output() clearAll: EventEmitter<any>;
  options = {
    onUpdate: (event: any) => {
      this.sortDown();
    },
  };

  allInfo$ = this.betService.allAddedBetsInCart$.asObservable();
  showCurrent = this.betService.showCurrentBet$.asObservable();

  constructor(
    private _layout: MainLayoutComponent,
    public betService: BetService,
    @Inject(PLATFORM_ID) private platformId: any,
    private cd: ChangeDetectorRef
  ) {
    this.clearAll = new EventEmitter<any>(null);

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.cd.detectChanges();
  }


  ngOnInit(): void {
  }

  clearBetSlip() {
    this.clearAll.emit(true);
    this.betService.showCurrentBet$.next(false);
  }

  removeBetsOnCart(index, price) {
    this.betService.allAddedBetsInCart$.pipe(
      take(1),
      filter((res) => !!res),
      tap((res) => {
        res.splice(index, 1);
        this.betService.allAddedBetsInCart$.next(res);
      })
    ).subscribe();

    this.betService.totalAllBetsOnCart -= price
  }

  addNewBet() {
    if (this.info.totalPrice == 0) {
      this.betService.showCurrentBet$.next(true);
      return
    }

    this.betService.allAddedBetsInCart$.pipe(
      take(1),
      filter((res) => !!res),
      tap((res) => {
        res.push(this.info);
        this.betService.allAddedBetsInCart$.next(res);
      })
    ).subscribe();

    this.betService.totalAllBetsOnCart += this.info.totalPrice

    this.clearBetSlip()
    this.betService.showCurrentBet$.next(true);
    this.cd.detectChanges();
  }



  async sortDown() {
    let selectedRunners = [];
    this.info.selectedRunnersObjIterable.forEach((element) => {
      element[1].forEach((elm) => {
        selectedRunners.push(elm);
      });
    });
    selectedRunners.forEach((elm, index) => {
      elm['custom_oreder'] = index;
    });
    this.info.selectedRunners = selectedRunners;
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        this._layout.betSlip$.next({
          ...this.info,
        });
      }, 150);
    }
  }
}
